module.exports = __webpack_public_path__ + "img/buderim.1c10a69.png";